/**
 * Replace all DOM elements with data attribute data-number-formatted
 * using the value from attribute and replace in tag formatted value.
 *
 * @author Stefan Lazarevic <stefan.l@scopicsoftware.com>
 * @since 02.04.2018
 */
;(function PhoneNumberFormater(global) {

        /**
         * Format phone number string in (xxx) xxx-xxxx format.
         * @param {String} number Number to format
         * @return {String} Phone number in format (xxx) xxx-xxxx
         */
        function formatNumber(number) {
            if (typeof number === 'string') {
                if (number === 'N/A') {
                    return number;
                }

                numberDigits = number.replace(/\D/g,'').split('');
                phoneNumberFormat = '(xxx) xxx-xxxx';
                phoneNumberFormatTokens = phoneNumberFormat.split('');
                xPosition = 0;

                return phoneNumberFormatTokens.reduce(function mapNumberTokens(formatedNumber, token) {
                    if (token === 'x') {
                        formatedNumber += numberDigits[xPosition] || '';
                        xPosition++;
                    } else {
                        formatedNumber += token;
                    }

                    return formatedNumber;
                }, "");
            }
        }

        function formatAllNumbers() {
                document.querySelectorAll("[data-number-formatted]").forEach(function (element, index) {
                    element.innerText = formatNumber(element.dataset.numberFormatted);
                });
        }

    window.onload = function() {
        formatAllNumbers();
    };

        window.formatAllNumbers = formatAllNumbers;

})(window);
